"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventAircraftDetailSchema = void 0;
const yup = __importStar(require("yup"));
const utilities_1 = require("../../../utilities");
const enums_1 = require("../../../enums");
exports.eventAircraftDetailSchema = yup.object().shape({
    id: yup.string().notRequired(),
    tailNumber: yup.string().notRequired(),
    parkingSpot: yup.string().notRequired(),
    fulRequired: yup.string().matches(/^\d{1,9}$/, "Ful Required Must be only digits").notRequired(),
    aircraftStatus: yup.string().oneOf((0, utilities_1.getEnumValues)(enums_1.AircraftStatusType)).nullable().default(enums_1.AircraftStatusType.EMPTY).notRequired(),
    reverseTail: yup.string().notRequired(),
});
